// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search[data-v-3f06be44] {\n  width: 10px;\n  height: 10px;\n}", ""]);
// Exports
module.exports = exports;
